<div id="main" class="internal">
  <div id="amministrazione" class="section amministrazione">
    <div class="content-body">
      <div class="title">
        <h1>{{ "passenger_reservation.title" | translate }}</h1>
      </div>
      <div class="content">
        <div class="table bookings">
          <div class="ca-card">
            <p-table
              [value]="datasource"
              [paginator]="true"
              [rows]="5"
              [tableStyle]="{ width: '100%' }"
              styleClass="p-datatable-sm p-datatable-striped"
            >
              <ng-template pTemplate="header">
                <tr>
                  <th pSortableColumn="creation_date">
                    {{ "passenger_reservation.booking_date" | translate }}
                    <p-sortIcon field="creation_date" />
                  </th>
                  <th pSortableColumn="restaurant_name">
                    {{ "passenger_reservation.restaurant_name" | translate }}
                    <p-sortIcon field="restaurant_name" />
                  </th>
                  <th pSortableColumn="slot_start">
                    {{ "passenger_reservation.booking_time" | translate }}
                    <p-sortIcon field="slot_start" />
                  </th>
                  <th pSortableColumn="number_of_users">
                    {{ "passenger_reservation.attendees" | translate }}
                    <p-sortIcon field="number_of_users" />
                  </th>
                  <th>{{ "passenger_reservation.actions" | translate }}</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-data>
                <tr>
                  <td>{{ data.creation_date }}</td>
                  <td>{{ data.restaurant_name }}</td>
                  <td>{{ data.slot_start }}</td>
                  <td>{{ data.number_of_users }}</td>
                  <td>
                    <p-button
                      [text]="true"
                      icon="pi pi-pencil"
                      [pTooltip]="'edit' | translate"
                      tooltipPosition="top"
                      (onClick)="UpdateBooking(data)"
                    />
                    <p-button
                      [text]="true"
                      icon="pi pi-trash"
                      [pTooltip]="'delete' | translate"
                      tooltipPosition="top"
                      (onClick)="DeleteBooking(data)"
                    />
                  </td>
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage">
                <tr>
                  <td colspan="5">
                    <div class="message">
                      <div class="icon">
                        <img
                          src="../../../assets/images/Info.svg"
                          alt="Info icon"
                        />
                      </div>
                      <div
                        class="text"
                        [innerHTML]="
                          'passenger_reservation.no_reservations' | translate
                        "
                      ></div>
                    </div>
                  </td>
                </tr>
              </ng-template>
              <ng-template pTemplate="paginatorright">
                <p-button
                  type="button"
                  label="
                {{ 'passenger_reservation.new_booking' | translate }}
                "
                  icon="pi pi-plus"
                  styleClass="p-button-text"
                  (onClick)="NewBooking()"
                />
              </ng-template>
            </p-table>
          </div>
        </div>
        <div class="buttons">
          <button class="costa-button outline" type="button" (click)="Back()">
            {{ "back" | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
